"use strict"

import React from "react"

import { PageTitle } from "../../../config/AppSettingsConfigProvider"
import Supervisor from "./widget/SupervisorWidget"
import ServiceLogs from "./widget/ServiceLogsWidget"

export default function SystemManagementScreen({ intl }) {
  return (
    <div className={"content-block full-height-min"}>
      <PageTitle glyph={"wrench"} id={"administration.system-management"} description={"System Management"} />
      <hr />

      <div className={"row"}>
        <div className={"col-4"}>
          <Supervisor intl={intl} />
        </div>
        <div className={"col-4"}>
          <ServiceLogs intl={intl} />
        </div>
      </div>
    </div>
  )
}
